/**
 * Catálogo de los 19 productos financieros vigentes (Fase 3.3).
 *
 * Copia de solo-catálogo (sin fórmula, sin TIA_ESCALA) del backend
 * `backend/src/domain/finance/productos.js`, para que el frontend pueda
 * armar el selector de producto/plazo en /creditos/nuevo sin importar
 * código de servidor. Si el catálogo cambia en el backend, este archivo
 * debe actualizarse a mano — no hay build step compartido entre ambos.
 *
 * La TIA se conserva aquí como dato interno (nunca se muestra al cliente,
 * Fase 4.4 sección 2), no como insumo de cálculo operativo.
 */

export const TIPO_CREDITO = Object.freeze({
  PERSONAL: 'PERSONAL',
  GRUPAL: 'GRUPAL',
  COLOCADORA: 'COLOCADORA'
});

export const MODALIDAD_FRECUENCIA = Object.freeze({
  SEMANAL: 'SEMANAL',
  QUINCENAL: 'QUINCENAL'
});

export const TIPO_PROGRAMACION_PAGO = Object.freeze({
  INTERVALO_DIAS: 'INTERVALO_DIAS',
  FECHAS_FIJAS_MES: 'FECHAS_FIJAS_MES'
});

export const PRODUCTOS_VIGENTES = Object.freeze([
  // --- PERSONAL — Semanal ---
  { codigo: 'PERSONAL_SEMANAL_10', legacyName: 'SEMANAL 65', tipoCredito: 'PERSONAL', modalidadFrecuencia: 'SEMANAL', numeroPagos: 10, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 338.00 },
  { codigo: 'PERSONAL_SEMANAL_12', legacyName: '12 SEMANAL 31', tipoCredito: 'PERSONAL', modalidadFrecuencia: 'SEMANAL', numeroPagos: 12, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 248.00 },
  { codigo: 'PERSONAL_SEMANAL_14', legacyName: '14 SEMANAL 15', tipoCredito: 'PERSONAL', modalidadFrecuencia: 'SEMANAL', numeroPagos: 14, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 227.00 },
  { codigo: 'PERSONAL_SEMANAL_16', legacyName: '16 SEMANAL 02', tipoCredito: 'PERSONAL', modalidadFrecuencia: 'SEMANAL', numeroPagos: 16, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 206.00 },
  { codigo: 'PERSONAL_SEMANAL_18', legacyName: '18 SEMANAL 92', tipoCredito: 'PERSONAL', modalidadFrecuencia: 'SEMANAL', numeroPagos: 18, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 190.00 },
  { codigo: 'PERSONAL_SEMANAL_20', legacyName: '20 SEMANAL 85', tipoCredito: 'PERSONAL', modalidadFrecuencia: 'SEMANAL', numeroPagos: 20, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 182.00 },

  // --- PERSONAL — Quincenal (fechas fijas del mes) ---
  { codigo: 'PERSONAL_QUINCENAL_08', legacyName: '8 QUINC.', tipoCredito: 'PERSONAL', modalidadFrecuencia: 'QUINCENAL', numeroPagos: 8, tipoProgramacionPago: 'FECHAS_FIJAS_MES', diasFijosMes: [15, 30], tia: 175.00 },
  { codigo: 'PERSONAL_QUINCENAL_10', legacyName: '10 QUINC.', tipoCredito: 'PERSONAL', modalidadFrecuencia: 'QUINCENAL', numeroPagos: 10, tipoProgramacionPago: 'FECHAS_FIJAS_MES', diasFijosMes: [15, 30], tia: 149.00 },
  { codigo: 'PERSONAL_QUINCENAL_12', legacyName: '12 QUINC.', tipoCredito: 'PERSONAL', modalidadFrecuencia: 'QUINCENAL', numeroPagos: 12, tipoProgramacionPago: 'FECHAS_FIJAS_MES', diasFijosMes: [15, 30], tia: 135.00 },
  { codigo: 'PERSONAL_QUINCENAL_14', legacyName: '14 QUINC.', tipoCredito: 'PERSONAL', modalidadFrecuencia: 'QUINCENAL', numeroPagos: 14, tipoProgramacionPago: 'FECHAS_FIJAS_MES', diasFijosMes: [15, 30], tia: 130.00 },

  // --- GRUPAL — Semanal ---
  { codigo: 'GRUPAL_SEMANAL_12', legacyName: 'GRUPAL 115', legacyCodeAnterior: 'GRUPALITO12_115', tipoCredito: 'GRUPAL', modalidadFrecuencia: 'SEMANAL', numeroPagos: 12, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 165.00 },
  { codigo: 'GRUPAL_SEMANAL_14', legacyName: 'GRUPAL 98', legacyCodeAnterior: 'GRUPALITO14_98', tipoCredito: 'GRUPAL', modalidadFrecuencia: 'SEMANAL', numeroPagos: 14, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 138.00 },
  { codigo: 'GRUPAL_SEMANAL_16', legacyName: 'GRUPAL 87', legacyCodeAnterior: 'GRUPALITO16_87', tipoCredito: 'GRUPAL', modalidadFrecuencia: 'SEMANAL', numeroPagos: 16, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 127.50 },

  // --- GRUPAL — Quincenal (intervalo exacto de 14 días) ---
  { codigo: 'GRUPAL_QUINCENAL_06', legacyName: 'GRUPAL QN 6', tipoCredito: 'GRUPAL', modalidadFrecuencia: 'QUINCENAL', numeroPagos: 6, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 14, tia: 107.00 },
  { codigo: 'GRUPAL_QUINCENAL_08', legacyName: 'GRUPAL QN 8', tipoCredito: 'GRUPAL', modalidadFrecuencia: 'QUINCENAL', numeroPagos: 8, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 14, tia: 99.00 },
  { codigo: 'GRUPAL_QUINCENAL_10', legacyName: 'GRUPAL QN 10', tipoCredito: 'GRUPAL', modalidadFrecuencia: 'QUINCENAL', numeroPagos: 10, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 14, tia: 86.50 },

  // --- COLOCADORA — Semanal ---
  { codigo: 'COLOCADORA_SEMANAL_14', legacyName: 'COLOCADORA 14', tipoCredito: 'COLOCADORA', modalidadFrecuencia: 'SEMANAL', numeroPagos: 14, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 243.00 },
  { codigo: 'COLOCADORA_SEMANAL_15', legacyName: 'COLOCADORA 15', tipoCredito: 'COLOCADORA', modalidadFrecuencia: 'SEMANAL', numeroPagos: 15, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 226.00 },
  { codigo: 'COLOCADORA_SEMANAL_16', legacyName: 'COLOCADORA 16', tipoCredito: 'COLOCADORA', modalidadFrecuencia: 'SEMANAL', numeroPagos: 16, tipoProgramacionPago: 'INTERVALO_DIAS', intervaloDias: 7, tia: 212.50 }

  // COLOCADORA — Quincenal: PENDIENTE (Fase 3.3, sección 1). No se agrega
  // ninguna entrada — inventar un producto aquí sería exactamente lo que
  // esa fase prohíbe.
]);

/** Modalidades permitidas por tipo de crédito (Fase 4.4, sección 4). */
export const MODALIDADES_POR_TIPO = Object.freeze({
  PERSONAL: [
    { valor: 'SEMANAL', etiqueta: 'Semanal' },
    { valor: 'QUINCENAL', etiqueta: 'Quincenal (calendario 15/30)' }
  ],
  GRUPAL: [
    { valor: 'SEMANAL', etiqueta: 'Semanal' },
    { valor: 'QUINCENAL', etiqueta: 'Quincenal (14 días)' }
  ],
  COLOCADORA: [{ valor: 'SEMANAL', etiqueta: 'Semanal' }]
  // COLOCADORA Quincenal queda PENDIENTE — no se ofrece como opción hasta
  // que exista catálogo vigente confirmado.
});

export function obtenerProductoPorCodigo(codigo) {
  return PRODUCTOS_VIGENTES.find((p) => p.codigo === codigo) || null;
}

export function productosCompatibles(tipoCredito, modalidad) {
  return PRODUCTOS_VIGENTES.filter(
    (p) => p.tipoCredito === tipoCredito && p.modalidadFrecuencia === modalidad
  );
}

/** Descripción entendible de frecuencia/programación para el operador. */
export function describirFrecuencia(producto) {
  if (!producto) return '—';
  if (producto.tipoProgramacionPago === 'INTERVALO_DIAS') {
    return producto.intervaloDias === 7 ? 'Semanal' : `Cada ${producto.intervaloDias} días`;
  }
  return 'Quincenal (15 / fin de mes operativo)';
}

/** "14 pagos semanales", "8 pagos quincenales calendario", etc. */
export function describirPlazo(producto) {
  if (!producto) return '—';
  if (producto.tipoProgramacionPago === 'FECHAS_FIJAS_MES') {
    return `${producto.numeroPagos} pagos quincenales (calendario)`;
  }
  if (producto.intervaloDias === 7) {
    return `${producto.numeroPagos} pagos semanales`;
  }
  return `${producto.numeroPagos} pagos cada ${producto.intervaloDias} días`;
}

/**
 * Forma compacta "N pagos · tipo", usada en tarjetas de producto y en el
 * listado. Ej: "12 pagos · Quincenal calendario", "16 pagos · Semanal".
 */
export function describirPagosTipo(producto) {
  if (!producto) return '—';
  const tipo = producto.tipoProgramacionPago === 'FECHAS_FIJAS_MES'
    ? 'Quincenal calendario'
    : describirFrecuencia(producto);
  return `${producto.numeroPagos} pagos · ${tipo}`;
}
